import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ServiceUnavailableError extends CodedError {
  static get errorName() {
    return errorCodes.serviceUnavailableError.code;
  }

  constructor(message: string = errorCodes.serviceUnavailableError.message) {
    super(message);
    this.code = errorCodes.serviceUnavailableError.code;
    this.message = `${message} ${errorCodes.serviceUnavailableError.code}`;
    this.name = errorCodes.serviceUnavailableError.name;
    this.status = errorCodes.serviceUnavailableError.status;
  }
}
